import {
  prepareRequest
} from './request'

export const getClientDepositLimits = () => {
  const request = prepareRequest({
    url: 'client/client:get-deposit-limits',
    method: 'GET'
  })

  return request()
}

export const getClientLossLimits = (options) => {
  const request = prepareRequest({
    url: 'client/client:find-spent-limits',
    method: 'POST'
  })

  return request(options)
}

export const setClientDepositLimits = (options) => {
  const request = prepareRequest({
    url: 'client/client:set-deposit-limits',
    method: 'POST'
  })

  return request(options)
}

export const setClientLossLimits = (options) => {
  const request = prepareRequest({
    url: 'client/client:set-spent-limits',
    method: 'POST'
  })

  return request(options)
}

export const getRealityCheckSettings = () => {
  const request = prepareRequest({
    url: 'client/reality-check:get-reality-check-settings',
    method: 'GET'
  })

  return request()
}

export const setSelfExclusionSettings = (options) => {
  const request = prepareRequest({
    url: 'client/client:set-self-exclusion-settings',
    method: 'POST'
  })

  return request(options)
}

export const getSelfExclusionSettings = () => {
  const request = prepareRequest({
    url: 'client/client:get-self-exclusion-settings',
    method: 'GET'
  })

  return request()
}

export const setRealityCheckSettings = (options) => {
  const request = prepareRequest({
    url: 'client/reality-check:set-reality-check-settings',
    method: 'POST'
  })

  return request(options)
}

export const realityCheckPing = () => {
  const request = prepareRequest({
    url: 'client/reality-check:ping',
    method: 'POST'
  })

  return request()
}
